import { render, staticRenderFns } from "./DraftTip.vue?vue&type=template&id=38c6a856&scoped=true"
import script from "./DraftTip.vue?vue&type=script&lang=js"
export * from "./DraftTip.vue?vue&type=script&lang=js"
import style0 from "./DraftTip.vue?vue&type=style&index=0&id=38c6a856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c6a856",
  null
  
)

export default component.exports